import type { IPosRequest } from 'autogen/swagger/all';
import useRequestContext from 'hooks/user/useRequestContext';

export default function usePointOfSaleRequest() {
    const request = useRequestContext();

    return request?.posRequest || ({} as IPosRequest);
}
